/**
 * Assistance technicien.
 */
import { MessageSquare, Phone } from 'lucide-react';
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { DashboardLayout } from '@/components/dashboard/dashboard-layout';

export function TechnicianAssistancePage() {
  return (
    <DashboardLayout variant="technicien" title="Assistance">
      <div className="grid gap-4 md:grid-cols-2">
        <Card>
          <CardHeader className="flex flex-row items-start gap-3">
            <Phone className="h-5 w-5 text-bcl-blue" />
            <div>
              <CardTitle className="text-base">Hotline technique</CardTitle>
              <CardDescription>+33 1 00 00 00 00 (7j/7 8h-20h).</CardDescription>
            </div>
          </CardHeader>
        </Card>
        <Card>
          <CardHeader className="flex flex-row items-start gap-3">
            <MessageSquare className="h-5 w-5 text-bcl-blue" />
            <div>
              <CardTitle className="text-base">Contact admin BCL</CardTitle>
              <CardDescription>
                Contactez votre référent admin pour toute question dossier.
              </CardDescription>
            </div>
          </CardHeader>
        </Card>
      </div>
    </DashboardLayout>
  );
}
